<div class="helper-container">
  <ion-grid class="header-container">
    <ion-row>
      <ion-col size="3">
        <app-back-button (clicked)="salir()" [text]="'Volver'">
        </app-back-button>
      </ion-col>
    </ion-row>
    <ion-row class="title-container mt-8">
      <div class="title-helper"><strong>¿Qué quieres modificar?</strong></div>
    </ion-row>
    <ion-row>
      <div class="helper-subtitle mt-14">Selecciona una opción</div>
    </ion-row>
  </ion-grid>

  <ion-grid class="option-container">
    <ion-button
      id="btn-option-modify-regime"
      (click)="openRegimenModificationModal()"
      (keypress)="true"
      fill="outline"
      [class.on-focus-button] = "buttonsFocus.regimen"
      (ionFocus)="onFocusButtonRegimen()"
      (ionBlur)="onFocusButtonRegimen()"
    >
      <div class="contenedor-label-y-icono">
        <ion-label class="helper-subtitle ion-text-wrap ion-text-left" slot="start"
          >Tu Régimen Tributario:
          <strong>
            Régimen {{ subscriptionDataToModify.taxRegimeCode }}</strong
          ></ion-label
        >
        <div slot="end" class="icon-container">
          <chevron-next-svg></chevron-next-svg>
        </div></div
    ></ion-button>
    <ion-button
      id="btn-option-modify-amount"
      (click)="openAmountModificationModal()"
      (keypress)="true"
      fill="outline"
      [class.on-focus-button] = "buttonsFocus.amount"
      (ionFocus)="onFocusButtonAmount()"
      (ionBlur)="onFocusButtonAmount()"
    >
      <div class="contenedor-label-y-icono">
        <ion-label class="helper-subtitle ion-text-wrap ion-text-left" slot="start"
          >Tu ahorro mensual:
          <strong style="white-space: nowrap">
            {{ savesBySubscription() }}</strong
          ></ion-label
        >
        <div slot="end" class="icon-container">
          <chevron-next-svg></chevron-next-svg>
        </div></div
    ></ion-button>
  </ion-grid>
</div>
